(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-luscent-tracker]');
  roots.forEach(initTracker);

  function initTracker(root) {
    if (root.dataset.trackerReady === 'true') return;
    root.dataset.trackerReady = 'true';

    var endpoint = (root.dataset.endpoint || '').replace(/\/$/, '');
    var form = root.querySelector('[data-tracker-form]');
    var loading = root.querySelector('[data-tracker-loading]');
    var errorBox = root.querySelector('[data-tracker-error]');
    var errorMessage = root.querySelector('[data-error-message]');
    var result = root.querySelector('[data-tracker-result]');
    var submit = form.querySelector('button[type="submit"]');
    var submitLabel = root.querySelector('[data-submit-label]');
    var trackAnother = root.querySelector('[data-track-another]');
    var lookupTabsContainer = root.querySelector('[data-lookup-tabs]');
    var lookupTabs = root.querySelectorAll('[data-lookup-tab]');
    var lookupPanels = root.querySelectorAll('[data-lookup-panel]');
    var verificationPanel = root.querySelector('[data-order-verification]');
    var orderBack = root.querySelector('[data-order-back]');
    var lookupMode = 'tracking';
    var orderStep = 'number';
    var pendingOrderNumber = '';

    lookupTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        setLookupMode(tab.dataset.lookupTab === 'order' ? 'order' : 'tracking', true);
      });
    });
    setLookupMode('tracking', false);

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!form.reportValidity()) return;
      var data = new FormData(form);
      if (lookupMode === 'order' && orderStep === 'number') {
        pendingOrderNumber = String(data.get('order_number') || '').trim();
        setOrderStep('verification', true);
        return;
      }
      var path = lookupMode === 'order' ? '/track/order' : '/track';
      var payload = lookupMode === 'order'
        ? {
            order_number: pendingOrderNumber,
            verification: String(data.get('verification') || '').trim()
          }
        : {
            tracking_number: String(data.get('tracking_number') || '').trim()
          };
      loadShipment(path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    });

    orderBack.addEventListener('click', function () {
      setOrderStep('number', true);
    });

    trackAnother.addEventListener('click', function () {
      result.hidden = true;
      errorBox.hidden = true;
      form.hidden = false;
      form.reset();
      pendingOrderNumber = '';
      setLookupMode('tracking', false);
      var trackingInput = form.querySelector('[name="tracking_number"]');
      if (trackingInput) trackingInput.focus();
      if (window.history && window.history.replaceState) {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('shipment');
        cleanUrl.hash = '';
        window.history.replaceState({}, '', cleanUrl.toString());
      }
    });

    var signedToken = '';
    var linkedTrackingNumber = '';
    window.dispatchEvent(new CustomEvent('luscent:shipment-token:8b735', {
      detail: {
        consume: function (token) {
          signedToken = token;
        }
      }
    }));
    window.dispatchEvent(new CustomEvent('luscent:tracking-number:4d219', {
      detail: {
        consume: function (trackingNumber) {
          linkedTrackingNumber = trackingNumber;
        }
      }
    }));
    if (!signedToken) {
      signedToken = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('shipment');
    }
    if (!linkedTrackingNumber) {
      linkedTrackingNumber = new URLSearchParams(window.location.hash.replace(/^#/, '')).get('tracking');
    }
    if (signedToken && /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(signedToken)) {
      if (window.history && window.history.replaceState) {
        var privateUrl = new URL(window.location.href);
        privateUrl.hash = '';
        window.history.replaceState({}, '', privateUrl.toString());
      }
      form.hidden = true;
      loadShipment('/shipment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: signedToken })
      });
    } else if (linkedTrackingNumber && /^[A-Za-z0-9-]{5,50}$/.test(linkedTrackingNumber)) {
      if (window.history && window.history.replaceState) {
        var trackingUrl = new URL(window.location.href);
        trackingUrl.hash = '';
        window.history.replaceState({}, '', trackingUrl.toString());
      }
      form.hidden = true;
      loadShipment('/track', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ tracking_number: linkedTrackingNumber })
      });
    }

    async function loadShipment(path, options) {
      if (!/^https:\/\//i.test(endpoint)) {
        showError('Live tracking is being connected. Please try again shortly.');
        return;
      }
      setLoading(true);
      errorBox.hidden = true;
      result.hidden = true;
      try {
        var response = await fetch(endpoint + path, Object.assign({
          mode: 'cors',
          credentials: 'omit',
          cache: 'no-store',
          referrerPolicy: 'no-referrer'
        }, options));
        var body = await response.json().catch(function () { return {}; });
        if (!response.ok || !body.found || !body.order) {
          throw new TrackerError(body.message || 'We could not load that shipment.');
        }
        renderOrder(body.order);
        form.hidden = true;
        result.hidden = false;
        result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        showError(error instanceof TrackerError
          ? error.message
          : 'Tracking is taking a short pause. Please try again in a moment.');
        form.hidden = false;
      } finally {
        setLoading(false);
      }
    }

    function setLoading(active) {
      loading.hidden = !active;
      submit.disabled = active;
      submit.classList.toggle('is-loading', active);
      submitLabel.textContent = active ? 'Checking' : defaultSubmitLabel();
    }

    function showError(message) {
      errorMessage.textContent = message;
      errorBox.hidden = false;
      result.hidden = true;
    }

    function setLookupMode(mode, focusField) {
      lookupMode = mode;
      orderStep = 'number';
      pendingOrderNumber = '';
      lookupTabs.forEach(function (tab) {
        var selected = tab.dataset.lookupTab === mode;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
      });
      lookupPanels.forEach(function (panel) {
        panel.hidden = panel.dataset.lookupPanel !== mode;
      });
      var trackingInput = form.querySelector('[name="tracking_number"]');
      var orderInput = form.querySelector('[name="order_number"]');
      var verificationInput = form.querySelector('[name="verification"]');
      lookupTabsContainer.hidden = false;
      verificationPanel.hidden = true;
      orderBack.hidden = true;
      if (trackingInput) {
        trackingInput.required = mode === 'tracking';
        trackingInput.disabled = mode !== 'tracking';
      }
      if (orderInput) {
        orderInput.required = mode === 'order';
        orderInput.disabled = mode !== 'order';
      }
      if (verificationInput) {
        verificationInput.required = false;
        verificationInput.disabled = true;
        verificationInput.value = '';
      }
      setText('[data-form-heading]', 'Find your shipment');
      setText('[data-form-instruction]', 'Use your tracking number or order number.');
      submitLabel.textContent = defaultSubmitLabel();
      if (focusField) {
        errorBox.hidden = true;
        var target = mode === 'order' ? orderInput : trackingInput;
        if (target) target.focus();
      }
    }

    function setOrderStep(step, focusField) {
      if (lookupMode !== 'order') return;
      orderStep = step === 'verification' ? 'verification' : 'number';
      var orderInput = form.querySelector('[name="order_number"]');
      var verificationInput = form.querySelector('[name="verification"]');
      var orderPanel = form.querySelector('[data-lookup-panel="order"]');
      var showingVerification = orderStep === 'verification';

      lookupTabsContainer.hidden = showingVerification;
      orderPanel.hidden = showingVerification;
      verificationPanel.hidden = !showingVerification;
      orderBack.hidden = !showingVerification;
      orderInput.required = !showingVerification;
      orderInput.disabled = showingVerification;
      verificationInput.required = showingVerification;
      verificationInput.disabled = !showingVerification;

      setText(
        '[data-form-heading]',
        showingVerification ? 'One quick check' : 'Find your shipment'
      );
      setText(
        '[data-form-instruction]',
        showingVerification
          ? 'Enter the email, first name or postcode used for this order.'
          : 'Use your tracking number or order number.'
      );
      submitLabel.textContent = defaultSubmitLabel();
      errorBox.hidden = true;
      if (focusField) {
        var target = showingVerification ? verificationInput : orderInput;
        if (target) target.focus();
      }
    }

    function defaultSubmitLabel() {
      if (lookupMode === 'order' && orderStep === 'number') return 'Continue';
      return 'Track my order';
    }

    function renderOrder(order) {
      var timelineTimeZone = safeTimeZone(order.timeline_time_zone);
      var orderLabel = root.querySelector('[data-order-label]');
      if (orderLabel) orderLabel.hidden = !order.order_number;
      setText('[data-order-number]', order.order_number || '');
      setText('[data-status-label]', order.status_label || 'Shipment update');
      var statusDetail = typeof order.status_detail === 'string'
        ? order.status_detail.trim()
        : '';
      var latestScanTime = formatTime(order.latest_scan_at, timelineTimeZone);
      if (
        order.status_code === 'IN_TRANSIT'
        && typeof order.latest_scan_locality === 'string'
        && order.latest_scan_locality.trim()
        && latestScanTime
      ) {
        statusDetail = 'Last scanned in '
          + order.latest_scan_locality.trim()
          + ' at '
          + latestScanTime
          + '.';
      }
      var statusDetailElement = root.querySelector('[data-status-detail]');
      if (statusDetailElement) {
        statusDetailElement.hidden = !statusDetail;
        statusDetailElement.textContent = statusDetail;
      }
      var collectionVisible = renderCollection(order);
      renderProgress(
        Number(order.stage_index) || 1,
        order.status_code,
        collectionVisible
      );
      var allowedDeliveryPartners = {
        FedEx: true,
        'Australia Post': true,
        Evri: true
      };
      var deliveryPartner = allowedDeliveryPartners[order.delivery_partner]
        ? order.delivery_partner
        : '';
      var deliveryPartnerElement = root.querySelector('[data-delivery-partner]');
      var deliveryPartnerPrefix = root.querySelector(
        '[data-delivery-partner-prefix]'
      );
      var deliveryPartnerLink = root.querySelector(
        '[data-delivery-partner-link]'
      );
      var deliveryPartnerHosts = deliveryPartner === 'FedEx'
        ? ['fedex.com', 'www.fedex.com']
        : deliveryPartner === 'Evri'
          ? ['evri.com', 'www.evri.com']
          : [];
      var deliveryPartnerUrl = safeHttpsUrl(
        order.delivery_partner_url,
        deliveryPartnerHosts
      );
      setText(
        '[data-delivery-partner-name]',
        deliveryPartnerUrl
          ? deliveryPartner === 'Evri'
            ? 'Track with Evri'
            : 'Track Progress on FedEx Website'
          : deliveryPartner
      );
      if (deliveryPartnerPrefix) {
        deliveryPartnerPrefix.hidden = Boolean(deliveryPartnerUrl);
      }
      if (deliveryPartnerLink) {
        if (deliveryPartnerUrl) {
          deliveryPartnerLink.href = deliveryPartnerUrl;
        } else {
          deliveryPartnerLink.removeAttribute('href');
        }
        deliveryPartnerLink.classList.toggle(
          'is-linked',
          Boolean(deliveryPartnerUrl)
        );
      }
      if (deliveryPartnerElement) {
        deliveryPartnerElement.hidden = !deliveryPartner || collectionVisible;
      }
      var estimatedDelivery = formatEstimatedDelivery(
        order.estimated_delivery_from,
        order.estimated_delivery_to,
        timelineTimeZone
      );
      var estimatedDeliveryElement = root.querySelector(
        '[data-estimated-delivery]'
      );
      setText('[data-estimated-delivery-date]', estimatedDelivery);
      if (estimatedDeliveryElement) {
        estimatedDeliveryElement.hidden = !estimatedDelivery || collectionVisible;
      }
      var deliveryFinalisationNotice =
        typeof order.delivery_finalisation_notice === 'string'
          ? order.delivery_finalisation_notice.trim()
          : '';
      var deliveryFinalisationNoticeElement = root.querySelector(
        '[data-delivery-finalisation-notice]'
      );
      if (deliveryFinalisationNoticeElement) {
        deliveryFinalisationNoticeElement.textContent = deliveryFinalisationNotice;
        deliveryFinalisationNoticeElement.hidden = !deliveryFinalisationNotice;
      }
      renderActivities(order.activities, timelineTimeZone);
    }

    function renderCollection(order) {
      var card = root.querySelector('[data-collection-card]');
      if (!card) return false;

      var address = root.querySelector('[data-collection-address]');
      var hours = root.querySelector('[data-collection-hours]');
      var phoneRow = root.querySelector('[data-collection-phone-row]');
      var phone = root.querySelector('[data-collection-phone]');
      var items = root.querySelector('[data-collection-items]');
      var guidance = root.querySelector('[data-collection-guidance]');
      var trackingLink = root.querySelector('[data-collection-tracking-link]');
      var directions = root.querySelector('[data-collection-directions]');

      card.hidden = true;
      setText('[data-collection-location]', 'Collection point');
      clearElement(address);
      clearElement(hours);
      clearElement(items);
      if (address) address.hidden = true;
      if (hours) hours.hidden = true;
      if (phoneRow) phoneRow.hidden = true;
      if (phone) {
        phone.textContent = '';
        phone.removeAttribute('href');
      }
      if (guidance) {
        guidance.hidden = true;
        guidance.textContent = '';
      }
      if (trackingLink) {
        trackingLink.textContent = 'View carrier tracking';
        trackingLink.removeAttribute('href');
      }
      if (directions) {
        directions.hidden = true;
        directions.removeAttribute('href');
      }

      var details = order && order.collection_details;
      if (
        !details
        || typeof details.location_name !== 'string'
        || !details.location_name.trim()
      ) {
        return false;
      }

      var carrier = details.carrier === 'Australia Post'
        ? 'Australia Post'
        : details.carrier === 'FedEx'
          ? 'FedEx'
          : details.carrier === 'Evri'
            ? 'Evri'
            : '';
      var carrierHosts = carrier === 'Australia Post'
        ? ['auspost.com.au', 'www.auspost.com.au']
        : carrier === 'FedEx'
          ? ['fedex.com', 'www.fedex.com']
          : carrier === 'Evri'
            ? ['evri.com', 'www.evri.com']
            : [];
      var carrierUrl = safeHttpsUrl(details.carrier_tracking_url, carrierHosts);
      if (!carrier || !carrierUrl || !trackingLink) return false;

      setText('[data-collection-location]', details.location_name.trim());
      renderTextLines(address, details.address_lines);
      renderTextLines(hours, details.hours);

      if (typeof details.phone === 'string' && details.phone.trim() && phone && phoneRow) {
        var phoneText = details.phone.trim();
        var phoneHref = phoneText.replace(/[^0-9+]/g, '');
        phone.textContent = phoneText;
        if (phoneHref) phone.href = 'tel:' + phoneHref;
        phoneRow.hidden = false;
      }

      var safeItems = Array.isArray(details.items)
        ? details.items.filter(function (item) {
            return item
              && typeof item.title === 'string'
              && item.title.trim()
              && Number(item.quantity) >= 1;
          }).slice(0, 12)
        : [];
      if (items) {
        safeItems.forEach(function (item) {
          var row = document.createElement('li');
          var title = document.createElement('span');
          var quantity = document.createElement('span');
          title.textContent = item.title.trim();
          quantity.textContent = 'x ' + Math.min(100, Math.floor(Number(item.quantity)));
          row.appendChild(title);
          row.appendChild(quantity);
          items.appendChild(row);
        });
        items.hidden = safeItems.length === 0;
      }

      if (typeof details.guidance === 'string' && details.guidance.trim() && guidance) {
        guidance.textContent = details.guidance.trim();
        guidance.hidden = false;
      }

      trackingLink.href = carrierUrl;
      trackingLink.textContent = 'View ' + carrier + ' tracking';
      var directionsUrl = safeHttpsUrl(
        details.directions_url,
        ['google.com', 'www.google.com', 'maps.google.com']
      );
      if (directions && directionsUrl) {
        directions.href = directionsUrl;
        directions.hidden = false;
      }

      card.hidden = false;
      return true;
    }

    function clearElement(element) {
      if (element) element.textContent = '';
    }

    function renderTextLines(container, values) {
      if (!container) return;
      var lines = Array.isArray(values)
        ? values.filter(function (value) {
            return typeof value === 'string' && value.trim();
          }).slice(0, 8)
        : [];
      lines.forEach(function (line) {
        var paragraph = document.createElement('p');
        paragraph.textContent = line.trim();
        container.appendChild(paragraph);
      });
      container.hidden = lines.length === 0;
    }

    function safeHttpsUrl(value, allowedHosts) {
      if (typeof value !== 'string' || !Array.isArray(allowedHosts)) return '';
      try {
        var parsed = new URL(value);
        var hostname = parsed.hostname.toLowerCase();
        if (parsed.protocol !== 'https:' || allowedHosts.indexOf(hostname) === -1) {
          return '';
        }
        return parsed.toString();
      } catch (error) {
        return '';
      }
    }

    function renderActivities(activities, timelineTimeZone) {
      var list = root.querySelector('[data-tracking-activities]');
      if (!list) return;
      list.textContent = '';
      var safeActivities = Array.isArray(activities)
        ? activities.filter(function (activity) {
            return activity
              && typeof activity.title === 'string'
              && typeof activity.detail === 'string'
              && formatActivityDate(activity.time, timelineTimeZone);
          }).slice(0, 12)
        : [];
      list.hidden = safeActivities.length === 0;
      safeActivities.forEach(function (activity) {
        var item = document.createElement('li');
        item.className = 'lus-track__activity';
        item.setAttribute('data-tracking-activity', '');

        var date = document.createElement('time');
        date.dateTime = String(activity.time);
        date.textContent = formatActivityDate(
          activity.time,
          timelineTimeZone
        );
        date.setAttribute('data-tracking-activity-date', '');

        var title = document.createElement('strong');
        title.textContent = activity.title;
        title.setAttribute('data-tracking-activity-title', '');

        var detail = document.createElement('p');
        detail.textContent = activity.detail;
        detail.setAttribute('data-tracking-activity-detail', '');

        item.appendChild(date);
        item.appendChild(title);
        if (activity.detail.trim()) item.appendChild(detail);
        list.appendChild(item);
      });
    }

    function setText(selector, value) {
      var element = root.querySelector(selector);
      if (element) element.textContent = value;
    }

    function renderProgress(stageIndex, statusCode, collectionVisible) {
      setText(
        '[data-progress-step-label="4"]',
        statusCode === 'READY_FOR_PICKUP' || collectionVisible
          ? 'Ready for pickup'
          : 'Arriving today'
      );
      root.querySelectorAll('[data-progress-step]').forEach(function (step) {
        var index = Number(step.dataset.progressStep);
        step.classList.toggle('is-complete', index < stageIndex);
        step.classList.toggle('is-current', index === stageIndex);
        if (index === stageIndex) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
    }

    function safeTimeZone(value) {
      if (typeof value !== 'string' || !value.trim()) return '';
      try {
        new Intl.DateTimeFormat(undefined, {
          timeZone: value.trim()
        }).format(new Date(0));
        return value.trim();
      } catch (error) {
        return '';
      }
    }

    function formatDate(value, timelineTimeZone) {
      if (!value) return '';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      var options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      };
      if (timelineTimeZone) options.timeZone = timelineTimeZone;
      return new Intl.DateTimeFormat(undefined, options).format(date);
    }

    function formatEstimatedDelivery(fromValue, toValue, timelineTimeZone) {
      var fromLabel = formatDate(fromValue || toValue, timelineTimeZone);
      var toLabel = formatDate(toValue || fromValue, timelineTimeZone);
      if (!fromLabel || !toLabel) return '';
      return fromLabel === toLabel ? fromLabel : fromLabel + ' to ' + toLabel;
    }

    function formatActivityDate(value, timelineTimeZone) {
      if (!value) return '';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      var options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit'
      };
      if (timelineTimeZone) options.timeZone = timelineTimeZone;
      return new Intl.DateTimeFormat(undefined, options).format(date);
    }

    function formatTime(value, timelineTimeZone) {
      if (!value) return '';
      var date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      var options = {
        hour: 'numeric',
        minute: '2-digit'
      };
      if (timelineTimeZone) options.timeZone = timelineTimeZone;
      return new Intl.DateTimeFormat(undefined, options).format(date);
    }
  }

  function TrackerError(message) {
    this.name = 'TrackerError';
    this.message = message;
  }
  TrackerError.prototype = Object.create(Error.prototype);
  TrackerError.prototype.constructor = TrackerError;
})();
